import React, { useContext } from "react";
import { VideoPlayerContext } from "../../contexts/VideoPlayerContext/VideoPlayerContextProvider";
import styles from "./index.module.scss";

function SidePaneContainer({ sideComponent, mainComponent, sideOpen = false }) {
  const { isFullScreen } = useContext(VideoPlayerContext);

  return (
    <div
      className={`${styles.sidePane} ${
        isFullScreen && styles.sidePaneFullScreen
      }`}
    >
      <div className={styles.mainComponent}>{mainComponent}</div>
      <div
        className={styles.sideComponent}
        style={{
          width: sideOpen ? "35.25rem" : 0,
          opacity: sideOpen ? 1 : 0,
        }}
      >
        <React.Fragment>{sideComponent}</React.Fragment>
      </div>
      <div
        className={styles.sideComponentMobile}
        style={{
          height: sideOpen ? "calc(100% - 18.75rem)" : 0,
        }}
      >
        {sideComponent}
      </div>
    </div>
  );
}

export default SidePaneContainer;
